// Shared by every surface that links an order rating row to its detail page:
// a conversation-backed rating opens the RecoveryAI case, everything else
// opens the Reports rating detail page, keyed on the OrderRating HASHID (a
// raw integer id 404s there).
//
// Promoted out of
// scenes/Users/View/Activity/OrderFeedback/useOrderFeedback.ts (AI-1288) when
// the Orders tab (AI-1290, scenes/Users/View/Activity/Orders) became a second
// consumer within the same top-level Users scene — that file's own comment
// called for exactly this promotion ("a genuine third caller should promote
// this to a components/ or utilities/ helper") rather than a third scene-local
// copy. useOrderFeedback.ts now re-exports from here so its existing tests and
// callers are unaffected.
//
// A near-identical copy also lives in
// scenes/Reports/OrderFeedbackReport/useOrderRatings.ts. That one is a
// different top-level scene and out of scope for this change — a
// pre-existing duplicate, not one introduced here.
export const RATING_DETAIL_PATH = '/order_feedback/ratings'

export const getOrderRatingViewPath = (row: {
  id: string
  conversationId: string | null
}): string =>
  row.conversationId
    ? `/recovery_ai/cases/${row.conversationId}`
    : `${RATING_DETAIL_PATH}/${row.id}`
